import tagsActionTypes, { ActionTypes } from "../action-types";
import { CategoryFromServerType } from "../models/Category";
import { TagFromServerType, TagType } from "../models/Tag";

type TagOrCategoryType = TagFromServerType | CategoryFromServerType;

export function makeActions(actionTypes: ActionTypes) {
  function receiveTagsAndCategories(tags: Array<TagOrCategoryType>) {
    return {
      type: actionTypes.RECEIVE_TAGS_AND_CATEGORIES,
      payload: tags
    };
  }

  function createTag(tag: TagType) {
    return {
      type: actionTypes.CREATE_TAG,
      payload: tag
    };
  }

  function updateTag(tag: TagType) {
    return {
      type: actionTypes.UPDATE_TAG,
      payload: tag
    };
  }

  function deleteTag(tagId: string) {
    return {
      type: actionTypes.DELETE_TAG,
      payload: tagId
    };
  }

  return {
    receiveTagsAndCategories,
    createTag,
    updateTag,
    deleteTag
  };
}

export const { receiveTagsAndCategories, createTag, updateTag, deleteTag } =
  makeActions(tagsActionTypes);
